"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// all keys stored in the cache by this SDK will be prefixed with this value
var CACHE_PREFIX = 'profile:';

// cached for 1 minute
var CACHE_DURATION = 1;
function SDK(baseUrl, fetch, cacheInterface) {
  function _fetchJson(url) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, res, _res, data, text;
      options = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      if (options && options.body) {
        options.headers = _objectSpread(_objectSpread({}, options.headers || {}), {}, _defineProperty({}, 'content-type', 'application/json'));
      }
      // some of the sdks are used in the browswer where the native fetch is used.
      if (typeof window === 'undefined') {
        options.responseType = 'json';
        return Promise.resolve(fetch("".concat(baseUrl).concat(url), options)).then(function ($await_5) {
          try {
            res = $await_5;
            return $return(res.body);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      } else {
        return Promise.resolve(fetch("".concat(baseUrl).concat(url), options)).then(function ($await_6) {
          try {
            _res = $await_6;
            if (_res.ok) {
              return Promise.resolve(_res.json()).then($return, $error);
            } else {
              if (_res.headers.get('Content-Type').indexOf('application/json') !== -1) {
                return Promise.resolve(_res.json()).then(function ($await_8) {
                  try {
                    data = $await_8;
                    return $error(_objectSpread({
                      status: _res.status
                    }, data));
                  } catch ($boundEx) {
                    return $error($boundEx);
                  }
                }, $error);
              }
              return Promise.resolve(_res.text()).then(function ($await_9) {
                try {
                  text = $await_9;
                  return $error(text);
                } catch ($boundEx) {
                  return $error($boundEx);
                }
              }, $error);
            }
            return $If_2.call(this);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }.bind(this), $error);
      }
      function $If_2() {
        return $return();
      }
      return $If_2.call(this);
    });
  }
  var _cacheGet = function _cacheGet(key) {
    return cacheInterface.get("".concat(CACHE_PREFIX).concat(key));
  };
  var _cacheSet = function _cacheSet(key, value, ttl) {
    return cacheInterface.set("".concat(CACHE_PREFIX).concat(key), value, ttl);
  };
  var _cacheRemove = function _cacheRemove(key) {
    return cacheInterface.remove("".concat(CACHE_PREFIX).concat(key));
  };
  var _cacheClear = function _cacheClear() {
    return cacheInterface.clear();
  };
  var getRecoveryMethods = function getRecoveryMethods(personId) {
    return new Promise(function ($return, $error) {
      return Promise.resolve(_fetchJson("/recovery/".concat(encodeURIComponent(personId), "/methods"))).then($return, $error);
    });
  };
  var getPlainTextRecoveryMethods = function getPlainTextRecoveryMethods(personId) {
    return new Promise(function ($return, $error) {
      var cached, response;
      cached = _cacheGet("plaintext-recovery-".concat(personId));
      if (cached) {
        return $return(cached);
      }
      return Promise.resolve(_fetchJson("/recovery/".concat(encodeURIComponent(personId), "/methods/plaintext"))).then(function ($await_11) {
        try {
          response = $await_11;
          return $return(_cacheSet("plaintext-recovery-".concat(personId), response, CACHE_DURATION));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };
  var updateRecoveryMethods = function updateRecoveryMethods(personId, recoveryMethods) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(_fetchJson("/recovery/".concat(encodeURIComponent(personId), "/methods"), {
        method: 'PUT',
        body: JSON.stringify(recoveryMethods)
      })).then(function ($await_12) {
        try {
          response = $await_12;
          _cacheClear();
          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };
  var searchRecoveryMethods = function searchRecoveryMethods(_ref) {
    return new Promise(function ($return, $error) {
      var emailAddress, phoneNumber, body, cached, response;
      emailAddress = _ref.emailAddress, phoneNumber = _ref.phoneNumber;
      body = JSON.stringify({
        emailAddress: emailAddress,
        phoneNumber: phoneNumber
      });
      cached = _cacheGet(body);
      if (cached) {
        return $return(cached);
      }
      return Promise.resolve(_fetchJson('/recovery/search', {
        method: 'POST',
        body: JSON.stringify({
          emailAddress: emailAddress,
          phoneNumber: phoneNumber
        })
      })).then(function ($await_13) {
        try {
          response = $await_13;
          return $return(_cacheSet(body, response, CACHE_DURATION));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };
  var getImage = function getImage(personId, label) {
    return new Promise(function ($return, $error) {
      var cached, response;
      cached = _cacheGet("image-".concat(label, "-").concat(personId));
      if (cached) {
        return $return(cached);
      }
      var $Try_1_Post = function () {
        try {
          return $return();
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      var $Try_1_Catch = function (error) {
        try {
          // only throw error if its something other than image does not exist
          if (!/does not exist for person/.test(error.reason)) {
            throw new Error(error.reason);
          }
          return $return(_cacheSet("image-".concat(label, "-").concat(personId), null, CACHE_DURATION));
        } catch ($boundEx) {
          return $error($boundEx);
        }
      };
      try {
        return Promise.resolve(_fetchJson("/images/".concat(encodeURIComponent(personId), "/").concat(encodeURIComponent(label)))).then(function ($await_14) {
          try {
            response = $await_14;
            return $return(_cacheSet("image-".concat(label, "-").concat(personId), response, CACHE_DURATION));
          } catch ($boundEx) {
            return $Try_1_Catch($boundEx);
          }
        }, $Try_1_Catch);
      } catch (error) {
        $Try_1_Catch(error)
      }
    });
  };
  var getAvatar = function getAvatar(personId) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(getImage(personId, 'avatar')).then(function ($await_15) {
        try {
          response = $await_15;
          // getImage can return null; re-write to look like a successful response
          if (response === null) {
            response = {
              success: true,
              imageLabel: 'avatar',
              imageUrl: null
            };
          }
          // set avatarUrl for backwards compatibility
          response.avatarUrl = response.imageUrl;
          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };
  var getHeader = function getHeader(personId) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(getImage(personId, 'header')).then(function ($await_16) {
        try {
          response = $await_16;
          // getImage can return null; re-write to look like a successful response
          if (response === null) {
            response = {
              success: true,
              imageLabel: 'header',
              imageUrl: null
            };
          }
          // set headerUrl for backwards compatibility
          response.headerUrl = response.imageUrl;
          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };
  var updateImage = function updateImage(personId, label, _ref2) {
    return new Promise(function ($return, $error) {
      var imageData, crop, size, body, response;
      imageData = _ref2.imageData, crop = _ref2.crop, size = _ref2.size;
      body = {
        imageData: imageData
      };
      if (crop) {
        body.crop = crop;
      }
      if (size) {
        body.size = size;
      }
      if (label) {
        body.imageLabel = label;
      }
      return Promise.resolve(_fetchJson("/images/".concat(encodeURIComponent(personId)), {
        method: 'PUT',
        body: JSON.stringify(body)
      })).then(function ($await_17) {
        try {
          response = $await_17;
          _cacheRemove("image-".concat(label, "-").concat(personId));
          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };
  var removeImage = function removeImage(personId, label) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(_fetchJson("/images/".concat(encodeURIComponent(personId), "/").concat(encodeURIComponent(label)), {
        method: 'DELETE'
      })).then(function ($await_18) {
        try {
          response = $await_18;
          _cacheRemove("image-".concat(label, "-").concat(personId));
          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  };
  return {
    getRecoveryMethods: getRecoveryMethods,
    getPlainTextRecoveryMethods: getPlainTextRecoveryMethods,
    updateRecoveryMethods: updateRecoveryMethods,
    searchRecoveryMethods: searchRecoveryMethods,
    getAvatar: getAvatar,
    getHeader: getHeader,
    getImage: getImage,
    updateImage: updateImage,
    removeImage: removeImage
  };
}
var noCache = {
  get: function get() {
    return undefined;
  },
  set: function set(key, value, lifetimeMins) {
    return value;
  },
  remove: function remove(key) {
    return undefined;
  },
  clear: function clear() {
    return undefined;
  }
};
module.exports = function (url, customFetch) {
  var cacheInterface = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noCache;
  if (typeof customFetch !== 'function') {
    throw new Error("".concat(_typeof(customFetch), " is not a function"));
  }
  return new SDK(url, customFetch, cacheInterface);
};
//# sourceMappingURL=index.js.map